<template>
    <div class="container d-flex justify-content-center text-center">
        <h2 class="text-white">
            {{ $t('message.forbidden') }}
        </h2>
    </div>
</template>

<script>
    export default {
        name: 'AccessDeny'
    };
</script>